import { useEffect } from 'react';
import { Grid } from './components';
import { useSocketIO } from './hooks';
import { initFaro, startHeartbeat } from './faro';

function App() {
	useSocketIO();

	useEffect(() => {
		initFaro();
		startHeartbeat();
	}, []);

	return (
		<div className="App">
			<Grid />
		</div>
	);
}

export default App;
